import "@arco-design/web-react/es/Result/style";
import _Result from "@arco-design/web-react/es/Result";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React from 'react';
import { useHistory } from 'react-router-dom';
import locale from './locale';
import useLocale from '@/utils/useLocale';
import styles from './style/index.module.less';
function Exception500() {
  const t = useLocale(locale);
  const history = useHistory();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(_Result, {
    className: styles.result,
    status: "500",
    subTitle: t['exception.result.500.description'],
    extra: /*#__PURE__*/React.createElement(_Button, {
      key: "back",
      type: "primary",
      onClick: () => history.goBack()
    }, t['exception.result.500.back'])
  }));
}
export default Exception500;